import app from 'flarum/common/app';
import Tooltip from 'flarum/common/components/Tooltip';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Widgets from 'flarum/extensions/afrux-forum-widgets-core/common/extend/Widgets';
import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';

var timeSince = function(date) {
	if (typeof date !== 'object') {
		date = new Date(date);
	}

	var seconds = Math.floor((new Date() - date) / 1000);
	var intervalType;

	var interval = Math.floor(seconds / 31536000);
	if (interval >= 1) {
		intervalType = 'y';
	} else {
		interval = Math.floor(seconds / 2592000);
		if (interval >= 1) {
			intervalType = 'm';
		} else {
			interval = Math.floor(seconds / 86400);
			if (interval >= 1) {
				intervalType = 'd';
			} else {
				interval = Math.floor(seconds / 3600);
				if (interval >= 1) {
					intervalType = "h";
				} else {
					interval = Math.floor(seconds / 60);
					if (interval >= 1) {
						intervalType = "m";
					} else {
						interval = seconds;
						intervalType = "s";
					}
				}
			}
		}
	}

	/*
	if (interval > 1 || interval === 0) {
		intervalType += 's';
	}
	*/

	return interval + ' ' + intervalType;
};

class TextFeedWidget extends Widget {
	className() {
		return 'Kemze-TextFeedWidget';
	}

	icon() {
		return app.forum.attribute('textFeedWidgetIcon') || 'fas fa-rss';
	}

	title() {
		return app.forum.attribute('textFeedWidgetTitle') || 'Feed';
	}
	content() {
		if (this.attrs.state && this.attrs.state.isLoading) {
			return <LoadingIndicator />;
		}

		const lines = app.forum.attribute('textFeedWidgetLines') || [];

		if (lines.length === 0) {
			return (
				<div className="Kemze-TextFeedWidget-empty">
				{app.translator.trans('kemze-text-feed-widget.forum.widget.empty')}
				</div>
			);
		}

		const regex = app.forum.attribute('textFeedWidgetRegex');
		const replacement = app.forum.attribute('textFeedWidgetReplacement');
		const transformed = regex
			? lines.map(line => line.replace(new RegExp(regex), replacement))
			: lines;

		return (
			<div className="Kemze-TextFeedWidget-list">
			{transformed.map((line, i) => {
				const children = [];
				const re = /<t:([^>]+)>/g;
				let last = 0, match;

				while ((match = re.exec(line)) !== null) {
					if (match.index > last) children.push(line.slice(last, match.index));
					const ts = dayjs(match[1] + "Z");
					children.push(
					  m(Tooltip, { text: ts.format('YYYY-MM-DD HH:mm:ss') + ' (UTC)', position:'left' },
						m('span', {
							className: 'Kemze-TextFeedWidget-timestamp',
							alt: ts.format('YYYY-MM-DD HH:mm:ss')
						}, timeSince(ts.toDate()))
					  )
					);
					last = match.index + match[0].length;
				}
				if (last < line.length) children.push(line.slice(last));

				return m('li', { key: i, className: 'Kemze-TextFeedWidget-item' }, ...children);
			})}
			</div>
		);
	}
}

app.initializers.add('kemze/text-feed-widget', () => {
	new Widgets().add({
		key: 'textFeed',
		component: TextFeedWidget,
		isUnique: true,
		placement: 'end',
		position: 1,
	}).extend(app, 'kemze-text-feed-widget');
});
